module.exports = __webpack_public_path__ + "static/media/5060.fed55ddf.jpg";